import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { classNames } from "../../../../../general/functions/propsComponent";

export default function ModalLeaveSession(props) {
  const { handleChoosen } = props;
  const [showModal, setShowModal] = useState(false);
  //   const dispatch = useDispatch();
  //   const storeDelete = useSelector(
  //     (state) => state.projectmodul_delete_assesseeScheduleSession
  //   );

  return (
    <>
      <button
        className={classNames(
          "btn-secondary bg-red-800 p-2 w-16 flex flex-col justify-center items-center whitespace-nowrap"
        )}
        onClick={() => {
          setShowModal(true);
        }}
      >
        <p className="text-sm font-semibold">Leave</p>
      </button>
      {showModal ? (
        <>
          <div className="backdrop-filter backdrop-blur-sm justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative  my-6 mx-auto w-full max-w-lg">
              {/*content*/}
              <div className="border-t-8  rounded-md border-red-500 shadow-lg relative flex flex-col w-full bg-secondary-500 outline-none focus:outline-none ">
                {/*header*/}
                <button
                  className="absolute top-2 right-4 p-1 ml-auto bg-transparent border-0 text-black opacity-4 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                  onClick={() => setShowModal(false)}
                >
                  <span className="bg-transparent text-white opacity-75 h-6 w-6 text-2xl block outline-none focus:outline-none">
                    ×
                  </span>
                </button>
                <div className="flex items-start justify-between pt-10 px-10 pb-0 ">
                  <h3 className="text-3xl font-semibold  text-red-500 ">
                    Leave Session
                  </h3>
                </div>

                {/*body*/}
                <div className="relative px-10 py-4  flex-auto ">
                  <p
                    className="
                    my-4 text-white text-lg leading-relaxed whitespace-normal"
                  >
                    Are you sure want to leave this session?{" "}
                  </p>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 rounded-b gap-1">
                  <button
                    className="btn-secondary"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn-primary bg-red-500"
                    type="button"
                    onClick={() => {
                      setShowModal(false);
                      handleChoosen("LEAVE");
                    }}
                  >
                    Leave Session
                  </button>
                  <button
                    className="btn-primary bg-red-500"
                    type="button"
                    onClick={() => {
                      setShowModal(false);
                      handleChoosen("LEAVE_ALL");
                    }}
                  >
                    End Session For All
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
